import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../../Support/classNames';

interface OwnProps {
    className?: string;
}

export const IndoorIntervalTablePromo: FunctionComponent<OwnProps> = ({className}) => {
    return (
        <div className={classNames('card intervaltable', className)} id="interval-table">
            <div className="card-title">
                <h5>Intervals</h5>
            </div>
            <div className="card-body-promo">
                <p>Get the full picture with Interval Tables</p>
                <p>
                    Break down your indoor workouts with detailed tables showing duration, distance, and split times for
                    every interval. Perfect for spotting trends, setting goals, and refining your pacing strategy.
                </p>
                <p>
                    <b>Level up your training — become an Advanced Member today!</b>
                </p>
                <a href="/account/subscriptions/checkout" className="btn btn-primary">
                    Become an Advanced Member
                </a>
            </div>
            <table className="table skeleton skeleton--opacity skeleton--static">
                <thead>
                    <tr>
                        <th className="intervaltable__cell">
                            <span>Duration</span>
                        </th>
                        <th className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>Distance</span>{' '}
                            <span className="intervaltable__cell-label">
                                <span>(m)</span>
                            </span>
                        </th>
                        <th className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>Ø Split</span>{' '}
                            <span className="intervaltable__cell-label">
                                <span>(/500m)</span>
                            </span>
                        </th>
                        <th className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>Ø Stroke rate</span>{' '}
                            <span className="intervaltable__cell-label">
                                <span>(/min)</span>
                            </span>
                        </th>
                        <th className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>Ø Power</span>{' '}
                            <span className="intervaltable__cell-label">
                                <span>(W)</span>
                            </span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="intervaltable__row">
                        <td className="intervaltable__cell">
                            <span>01:35.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>176</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>4:30.10</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>24</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>120</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row intervaltable__row--dimmed">
                        <td className="intervaltable__cell">
                            <span>05:02.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>76</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>32:57.88</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>18</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>85</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row">
                        <td className="intervaltable__cell">
                            <span>43:04.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>6,614</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>3:15.34</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>26</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>145</span>
                        </td>
                    </tr>
                    <tr className="intervaltable__row">
                        <td className="intervaltable__cell">
                            <span>43:04.00</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>6,614</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>3:15.34</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>26</span>
                        </td>
                        <td className="intervaltable__cell intervaltable__cell--rightalined">
                            <span>145</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
